export const MobiliarioImg = [
  {
    title: "Mobiliario",
    path: "../../soluciones/mobiliario/img1.jpg",
    cName: "carousel-img-mobiliario img1",
  },
  {
    title: "Mobiliario",
    path: "../../soluciones/mobiliario/img2.jpg",
    cName: "carousel-img-mobiliario img2",
  },
  {
    title: "Mobiliario",
    path: "../../soluciones/mobiliario/img3.jpg",
    cName: "carousel-img-mobiliario img3",
  },
  {
    title: "Mobiliario",
    path: "../../soluciones/mobiliario/img4.jpg",
    cName: "carousel-img-mobiliario img4",
  },
  {
    title: "Mobiliario",
    path: "../../soluciones/mobiliario/img5.jpg",
    cName: "carousel-img-mobiliario img5",
  },
  {
    title: "Mobiliario",
    path: "../../soluciones/mobiliario/img6.jpg",
    cName: "carousel-img-mobiliario img6",
  },
  {
    title: "Mobiliario",
    path: "../../soluciones/mobiliario/img7.jpg",
    cName: "carousel-img-mobiliario img7",
  },
  {
    title: "Mobiliario",
    path: "../../soluciones/mobiliario/img8.jpg",
    cName: "carousel-img-mobiliario img8",
  },
]
